import { reviver } from "mathjs"

/**
 * https://mathjs.org/docs/core/serialization.html#serialization
 * Returns a deep copy of the data, with all math.js types revived.
 * Useful for when we have to deserialize data that has previously been serialized to JSON and contains math.js types.
 */
export const reviveMathjsData = <T extends object = object>(data: T): T => JSON.parse(JSON.stringify(data), reviver)
